import { UserData } from "entities/user/model/types";
import CupIcon from "shared/assets/icons/cup.svg?react";
import clsx from "clsx";
import { AnimatedNumber } from "shared/ui";
import { UserAvatar } from "../UserAvatar/UserAvatar";
import styles from "./UserCard.module.scss";

interface Props {
    user: UserData;
    hideInfo?: boolean;
    reversed?: boolean;
    ratingDelta?: number;
    onClick?: () => void;
    hideInfoOnDesktop?: boolean;
    ariaLabel?: string;
}

export const UserCard = ({
    user,
    hideInfo,
    reversed,
    ratingDelta,
    onClick,
    hideInfoOnDesktop,
    ariaLabel,
}: Props) => {
    const content = (
        <>
            {!hideInfo && (
                <span className={styles.userInfo}>
                    <span className={styles.nickname}>{user.nickname}</span>
                    <span className={styles.rating}>
                        <CupIcon />

                        <AnimatedNumber
                            value={
                                ratingDelta !== undefined ? user.rating + ratingDelta : user.rating
                            }
                            from={user.rating}
                        />

                        {ratingDelta !== undefined && (
                            <span className={styles.ratingDelta}>
                                ({ratingDelta > 0 ? `+${ratingDelta}` : ratingDelta})
                            </span>
                        )}
                    </span>
                </span>
            )}

            <UserAvatar nickname={user.nickname} className={styles.userIcon} />
        </>
    );

    const className = clsx(
        styles.user,
        reversed && styles.reversed,
        hideInfoOnDesktop && styles.hideInfoOnDesktop,
        onClick && styles.interactive,
    );

    if (onClick) {
        return (
            <button type="button" className={className} onClick={onClick} aria-label={ariaLabel}>
                {content}
            </button>
        );
    }

    return <span className={className}>{content}</span>;
};
